var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemplateIcon(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116,
    height: 95,
    viewBox: "0 0 116 95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "template",
    transform: "translate(-6 -20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64410",
    "data-name": "Path 64410",
    d: "M73,110a4,4,0,0,1-4,4H11a4,4,0,0,1-4-4V46a4,4,0,0,1,4-4H69a4,4,0,0,1,4,4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64412",
    "data-name": "Path 64412",
    d: "M20,59H42V80H20Z",
    fill: "rgba(0,0,0,0)",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64413",
    "data-name": "Path 64413",
    d: "M73,110a4,4,0,0,1-4,4H11a4,4,0,0,1-4-4V46a4,4,0,0,1,4-4H69a4,4,0,0,1,4,4Z",
    fill: "rgba(0,0,0,0)",
    stroke: "#69707b",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64414",
    "data-name": "Path 64414",
    d: "M63,90H20",
    fill: "rgba(0,0,0,0)",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64415",
    "data-name": "Path 64415",
    d: "M63,97H20",
    fill: "rgba(0,0,0,0)",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64416",
    "data-name": "Path 64416",
    d: "M100,110a4,4,0,0,1-4,4H35a4,4,0,0,1-4-4V25a4,4,0,0,1,4-4H96a4,4,0,0,1,4,4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_104762",
    "data-name": "Group 104762"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64417",
    "data-name": "Path 64417",
    d: "M100,64v46a4,4,0,0,1-4,4H35a4,4,0,0,1-4-4V25a4,4,0,0,1,4-4H96a4,4,0,0,1,4,4V56",
    fill: "rgba(0,0,0,0)",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64418",
    "data-name": "Path 64418",
    d: "M87,53H44",
    fill: "rgba(0,0,0,0)",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64419",
    "data-name": "Path 64419",
    d: "M87,60H44",
    fill: "rgba(0,0,0,0)",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64420",
    "data-name": "Path 64420",
    d: "M87,67H44",
    fill: "rgba(0,0,0,0)",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64421",
    "data-name": "Path 64421",
    d: "M87,74H44",
    fill: "rgba(0,0,0,0)",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64422",
    "data-name": "Path 64422",
    d: "M87,81H44",
    fill: "rgba(0,0,0,0)",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64423",
    "data-name": "Path 64423",
    d: "M87,88H44",
    fill: "rgba(0,0,0,0)",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64424",
    "data-name": "Path 64424",
    d: "M87,95H44",
    fill: "rgba(0,0,0,0)",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_64425",
    "data-name": "Path 64425",
    d: "M121,110a4,4,0,0,1-4,4H57a4,4,0,0,1-4-4V68a4,4,0,0,1,4-4h60a4,4,0,0,1,4,4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64427",
    "data-name": "Path 64427",
    d: "M44,38H59v8H44Z",
    fill: "rgba(0,0,0,0)",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64428",
    "data-name": "Path 64428",
    d: "M121,110a4,4,0,0,1-4,4H57a4,4,0,0,1-4-4V68a4,4,0,0,1,4-4h60a4,4,0,0,1,4,4Z",
    fill: "rgba(0,0,0,0)",
    stroke: "#69707b",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64430",
    "data-name": "Path 64430",
    d: "M94,76h15v8H94Z",
    transform: "translate(1)",
    fill: "rgba(0,0,0,0)",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64431",
    "data-name": "Path 64431",
    d: "M88,92H67",
    fill: "rgba(0,0,0,0)",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64432",
    "data-name": "Path 64432",
    d: "M88,97H67",
    fill: "rgba(0,0,0,0)",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64433",
    "data-name": "Path 64433",
    d: "M88,102H67",
    fill: "rgba(0,0,0,0)",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64434",
    "data-name": "Path 64434",
    d: "M87,38H66",
    fill: "rgba(0,0,0,0)",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64435",
    "data-name": "Path 64435",
    d: "M87,45H66",
    fill: "rgba(0,0,0,0)",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateIcon);
export default __webpack_public_path__ + "static/media/TemplateIcon.54f537e4c441b3b9a086a8cb337f0d5f.svg";
export { ForwardRef as ReactComponent };